export const statusCancel = status => {
    switch ( String(status) ) {
        case 'CANCEL_FAIL':
            return { status: `ยกเลิกไม่สำเร็จ` , color: `dark`}
        case 'CANCEL':
            return { status: `ยกเลิกสำเร็จ` , color: `danger`} 
        case 'PENDING_CANCEL':
            return { status: `กำลังดำเนินการ` , color: `warning`} 
        default:
            return { status: `-` , color: `dark`}
    }
};